import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicInputGroup } from "../../../../Constant";
import { BASIC_INPUT_GROUP } from "../../../../Data/FormControl/InputGroups";
import { BasicInputGroupsCardBody } from "./BasicInputGroupsCardBody";
import { BasicInputGroupsCardFooter } from "./BasicInputGroupsCardFooter";

const BasicInputGroups = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={BasicInputGroup} span={BASIC_INPUT_GROUP} />
        <BasicInputGroupsCardBody/>
        <BasicInputGroupsCardFooter />
      </Card>
    </Col>
  );
};

export default BasicInputGroups;
